import { AxiosRequestConfig } from 'axios'
import {
  Region as Data,
  RegionCollection as Collection,
} from '@/typings/api/Region'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class AteRegionsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'ate/regions';

  public info(id: Data['id'], params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = `${id}/info/`
    const [url] = this.getUrl(path, params)
    type IResponse = { data: unknown }
    return this.request<null, IResponse>('GET', url, { params, ...config })
  }

  public getAllLK(params?: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'lk/'
    const [url] = this.getUrl(path, params)
    type IResponse = { data: unknown }
    return this.request<null, IResponse>('GET', url, { params, ...config })
  }
}
